import { useEffect, useState } from "react";
import Login from "./screens/Login";
import Workspace from "./screens/Workspace";

const KEY = "tspoon_ai_session";

interface Session { username: string; rememberme: string; }

export default function App() {
  const [session, setSession] = useState<Session | null>(null);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    try {
      const raw = localStorage.getItem(KEY);
      if (raw) setSession(JSON.parse(raw));
    } catch { /* ignore */ }
    setLoaded(true);
  }, []);

  function onLogin(s: Session, remember: boolean) {
    setSession(s);
    if (remember) localStorage.setItem(KEY, JSON.stringify(s));
  }

  function onLogout() {
    setSession(null);
    localStorage.removeItem(KEY);
  }

  if (!loaded) return null;
  if (!session) return <Login onLogin={onLogin} />;
  return <Workspace session={session} onLogout={onLogout} />;
}
